import {addEvent} from '../add-event'

export function clickSignInEvent(): boolean {
    return addEvent('loginPageClickSignIn', {})
}
